import React, { useEffect } from 'react';

import { styled } from '@mui/material/styles';
import { Box, Button, Divider, Grid } from '@sunwisesoftware/sunwise-ui';
import { push } from 'connected-react-router';
import { isNil } from 'lodash-es';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Link, Link as RouterLink } from 'react-router-dom';
import { createStructuredSelector } from 'reselect';

import { getIsGuess } from 'common/utils/helpers/session';

import Login1 from 'resources/login-1.svg?react';
import logotipo from 'resources/logotipo.svg';

import { loginUser } from './actions';
import LoginForm from './components/LoginForm';
import * as selectors from './selectors';

const StyledCol = styled(Grid)`
    background: #f6f8fa;
`;

const Container = ({
    errors,
    initialValues,
    isLoadingSession,
    loginUser,
    redirect,
}) => {
    const { i18n, t } = useTranslation();

    useEffect(() => {
        if (!getIsGuess()) redirect('/');
    }, []);

    const handleSubmit = (values) =>
        loginUser(values, (accountLanguage) => {
            if (!isNil(accountLanguage) && i18n.language !== accountLanguage)
                i18n.changeLanguage(accountLanguage);
        });

    return (
        <Grid
            container
            spacing={0}
            sx={{ alignItems: 'center', height: '100%' }}
        >
            <Grid
                size={{ xs: 'grow', lg: 9 }}
                sx={{ alignItems: 'center', display: 'flex', height: '100%' }}
            >
                <Box sx={{ margin: '0 auto', maxWidth: '670px', p: 2 }}>
                    <Box sx={{ textAlign: 'center' }}>
                        <img src={logotipo} width="238" />
                    </Box>

                    <Divider sx={{ margin: '3rem 0' }} />

                    <LoginForm
                        initialValues={initialValues}
                        onSubmit={handleSubmit}
                        isLoadingSession={isLoadingSession}
                        errors={errors}
                    />

                    <Box sx={{ textAlign: 'center', mb: 2 }}>
                        <Link to="/reset-password">
                            <small>{t('Did you forget your password?')}</small>
                        </Link>
                    </Box>

                    <Box sx={{ textAlign: 'center', py: 2 }}>
                        <Button
                            component={RouterLink}
                            to="/create-account"
                            variant="text"
                        >
                            {t('Sign up')}
                        </Button>
                    </Box>
                </Box>
            </Grid>

            <StyledCol
                size={{ md: 9 }}
                sx={{
                    alignItems: 'center',
                    display: { lg: 'flex', xs: 'none' },
                    height: '100%',
                    padding: 12,

                    '& svg': {
                        color: 'primary.main',
                        maxHeight: '600px',
                    },
                }}
            >
                <Login1 />
            </StyledCol>
        </Grid>
    );
};

Container.propTypes = {
    errors: PropTypes.array,
    initialValues: PropTypes.object,
    isLoadingSession: PropTypes.bool,
    loginUser: PropTypes.func,
    redirect: PropTypes.func,
};

const mapStateToProps = createStructuredSelector({
    errors: selectors.getErrorsLogin,
    initialValues: selectors.getInitialValues,
    isEmptyPosts: selectors.getPostsIsEmpty,
    isLoadingSession: selectors.getIsLoadingSession,
    postsData: selectors.getPostsData,
    validPassword: selectors.getValidPassword,
});

const mapDispatchToProps = (dispatch) => ({
    loginUser: (data, onSuccessCallback) =>
        dispatch(loginUser(data, onSuccessCallback)),
    redirect: (link) => dispatch(push(link)),
});

Container.propTypes = {
    errors: PropTypes.array,
    initialValues: PropTypes.object,
    isLoadingSession: PropTypes.bool,
    loginUser: PropTypes.func,
    redirect: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(Container);
